import { render, staticRenderFns } from "./NotasAvaliacao.vue?vue&type=template&id=19e515d8&scoped=true"
import script from "./NotasAvaliacao.vue?vue&type=script&lang=js"
export * from "./NotasAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./NotasAvaliacao.vue?vue&type=style&index=0&id=19e515d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e515d8",
  null
  
)

export default component.exports